var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 6.98V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6.981A3 3 0 0 0 19 4H5a3 3 0 0 0-3 2.98m2.293-.687A1 1 0 0 1 5 6h14a1 1 0 0 1 .888.54L12 11.798 4.112 6.54a1 1 0 0 1 .181-.247M20 8.869V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.869l7.445 4.963a1 1 0 0 0 1.11 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMail;